/**
 * The per-side activation-count label the round header shows beside LANCERS and HOSTILES. It
 * outlived the TURN rail it was written for (`decisions/0190`), whose chip split used to live here.
 */
import { activationCountsOnSide, type EncounterState, type Side } from "@lancer-vtt/domain";

/**
 * A side's `{used}/{used+remaining+inProgress}` counter string — computed by calling the domain's
 * {@link activationCountsOnSide} selector directly, **never re-derived from the units on the board**
 * (`projects/activation-count-readouts.md` R2/R4). Counting activated units over all units is the
 * defect that project fixed: it counts *units*, not *activations*, and it includes a Destroyed
 * hostile that never acted, so the denominator would drop the instant a hostile dies rather than
 * staying activation-stable within the round.
 */
export function turnRailLabel(state: EncounterState, side: Side): string {
  const { used, remaining, inProgress } = activationCountsOnSide(state, side);
  return `${used}/${used + remaining + inProgress}`;
}
